import axios from "axios";
import { useQuery } from "@tanstack/react-query";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });

const get = (url, params) => http.get(url, { params }).then((r) => r.data);

export const useSite = () => useQuery({ queryKey: ["site"], queryFn: () => get("/site"), staleTime: Infinity });
export const useServices = () => useQuery({
  queryKey: ["services"], queryFn: () => get("/services"),
  staleTime: Infinity, gcTime: Infinity, retry: 5, retryDelay: 1000, refetchOnWindowFocus: true,
});
export const useService = (slug) => useQuery({ queryKey: ["service", slug], queryFn: () => get(`/services/${slug}`) });
export const useLocations = () => useQuery({
  queryKey: ["locations"], queryFn: () => get("/locations"),
  staleTime: Infinity, gcTime: Infinity, retry: 5, retryDelay: 1000,
});
export const useLocation = (slug) => useQuery({ queryKey: ["location", slug], queryFn: () => get(`/locations/${slug}`) });
export const useBlog = () => useQuery({ queryKey: ["blog"], queryFn: () => get("/blog") });
export const usePost = (slug) => useQuery({ queryKey: ["post", slug], queryFn: () => get(`/blog/${slug}`) });
export const useReviews = () => useQuery({ queryKey: ["reviews"], queryFn: () => get("/reviews") });
export const useFaqCategories = () => useQuery({ queryKey: ["faqcats"], queryFn: () => get("/faqs/categories") });
export const useFaqs = (category, search, skip = 0) =>
  useQuery({ queryKey: ["faqs", category, search, skip], queryFn: () => get("/faqs", { category, search, skip, limit: 30 }) });

export const submitAppointment = (data) => http.post("/appointments", data).then((r) => r.data);

export const submitFeedback = (data) => http.post("/feedback", data).then((r) => r.data);

export const fetchLeads = (token) =>
  http.get("/admin/leads", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const deleteAllLeads = (token) =>
  http.delete("/admin/leads", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const deleteLead = (id, token) =>
  http.delete(`/admin/leads/${id}`, { headers: { "X-Admin-Token": token } }).then((r) => r.data);
